var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import { setupTrackErrors } from '../../utils/errorTracking';
import { updateSettingsEvent } from '../../utils/updateEvent';
import '../../components/Icon';
import i18n, { getLanguage, initI18N } from '../../utils/i18next';
import { brandVariables } from './BrandVariables';
import '../../components/toast/toastContainer';
/**
 * Update the settings in the window object
 * Only update settigns with a value
 * Imagine a user using the settings wrapper twice, once behind login and once without
 * The token could be overwritten by the second time and make the first instance not work anymore
 * Therefore just update the setting object
 * @param settings
 */
const updateSettings = (settings) => {
    if (window && settings) {
        const newSettings = { ...window.trustSettings };
        if (settings.accessToken) {
            newSettings.accessToken = settings.accessToken;
        }
        if (settings.apiUrl !== undefined) {
            newSettings.apiUrl = settings.apiUrl;
        }
        if (settings.brand) {
            newSettings.brand = settings.brand;
        }
        else {
            newSettings.brand = 'blocket';
        }
        window.trustSettings = newSettings;
    }
};
let Settings = class Settings extends BaseComponent {
    constructor() {
        super(...arguments);
        this.settings = window.trustSettings;
    }
    connectedCallback() {
        super.connectedCallback();
        setupTrackErrors();
    }
    willUpdate(_changedProperties) {
        var _a, _b, _c, _d;
        if (_changedProperties.has('settings') || (window.trustSettings && !this.settings)) {
            updateSettings(this.settings);
            if (i18n.isInitialized) {
                i18n.changeLanguage(getLanguage((_a = this.settings.brand) !== null && _a !== void 0 ? _a : 'blocket'));
            }
            else if (this.settings) {
                initI18N((_c = (_b = this.settings) === null || _b === void 0 ? void 0 : _b.brand) !== null && _c !== void 0 ? _c : 'blocket', ((_d = this.settings) === null || _d === void 0 ? void 0 : _d.apiUrl) === '' ? undefined : this.settings.apiUrl);
            }
            this.dispatchEvent(updateSettingsEvent);
        }
    }
    render() {
        if (!window.trustSettings || !i18n.isInitialized) {
            return nothing;
        }
        return html `
      <div style=${brandVariables(this.settings.brand)} class="text-primary">
          <slot></slot>
        <trust-toast-container>
        </trust-toast-container>
      </div>
    `;
    }
};
__decorate([
    property({ type: Object })
], Settings.prototype, "settings", void 0);
Settings = __decorate([
    customElement('trust-settings')
], Settings);
export { Settings };
//# sourceMappingURL=Settings.js.map